// extracted by mini-css-extract-plugin
export default {"mainFooter":"Footer_mainFooter__QH4o7"};